module.exports = __webpack_public_path__ + "img/3.01b5e65e.jpg";